<template>
<div>
<!-- <pre>{{countryObj}}</pre> -->
  <div v-if = "(selectedContinent && getContinentFromCountryCode(countryObj.id).includes(selectedContinent)) || selectedContinent == 'All' || selectedContinent == '' || !selectedContinent || selectedContinent == null">
    <router-link v-bind:to="'/' + 'countries' + '/' + $countrymap[countryObj.id]">
      <div class="card country-card" style="margin-bottom:40px; margin-left:auto; margin-right:auto; padding:30px;  background-blend-mode:overlay; 
        background-position: center center, center center; background-size: cover, cover;"
        
        :style="thumbnail != '' ? 
          {
            
            background: 'url(\'' + thumbnail + '\') rgba(255,255,255,0.8)',
            backgroundPosition: 'center center, center center',
            backgroundSize: 'cover, cover',
            backgroundRepeat: 'no-repeat, no-repeat'
            } 
            : 
            ''"
      > 
      
      <!-- <div style="width: 100%; height: 100%; background-size: cover; display: inline; position: absolute; left: 0; top: 0; background-position: center; opacity: 0.1;"
        :style="countryObj.thumbnail ? { backgroundImage: `url(${countryObj.thumbnail})`} : ''"
      ></div> -->
        <!-- <pre>{{countryObj}}</pre> -->
        
          <div class="columns has-text-left is-vcentered">
              <div class="column is-6-desktop is-full-mobile">
                  <router-link class="is-4 is-5-mobile title" style="display:inline-block; margin-bottom:0px" v-bind:to="'/' + 'countries' + '/' + $countrymap[countryObj.id]">{{$countrymap[countryObj.id]}}</router-link>

                  <!-- <span v-if="(routeObj.touring || routeObj.bikepacking)"> -->
                  <!-- <div>
                      <b-tag v-if="routeObj.touring" class="tag is-light" >touring</b-tag>
                      <b-tag v-if="routeObj.bikepacking" class="tag is-light" >bikepacking</b-tag>
                      <b-tag v-if="routeObj.road" class="tag is-light" >road</b-tag>
                      <b-tag v-if="routeObj.gravel" class="tag is-light" >gravel</b-tag>
                      <b-tag v-if="routeObj.singletrack" class="tag is-light" >singletrack</b-tag>
                      <b-tag v-if="routeObj.railtrail" class="tag is-light" >rail trail</b-tag>
                  </div> -->
                  <!-- </span> -->

              </div>
              <div class="column">
                <div class="columns is-mobile">
                  <div class="column">
                      <div class="small-label">Posts</div>
                      <p>{{countryObj.post_count}}</p>
                  </div>
                  
                  <div class="column">
                      <div class="small-label">Continent</div>
                      <p>{{getContinentFromCountryCode(countryObj.id)}}</p>
                  </div>
                </div>
              </div>

          </div>


          <!-- <p>{{getImage(routeObj.display_name)}}</p> -->
          
      </div>
      </router-link>
  </div>
  </div>
</template>

<script>
import {continent_map} from "../data.js";
export default {
  name: 'CountryRow',
  props: ['countryObj', 'selectedContinent'],
  data () {
    return {
      thumbnail: ""
    }
  },
  methods: {
    getContinentFromCountryCode(countrycode) {
      var match = continent_map.find(elem => elem["Two_Letter_Country_Code"] == countrycode);
      var continent = ""
      continent = match["Continent_Name"];
      return continent;
    }
  },
  mounted() {
    var that = this;
    // console.log(this.countryObj);
    this.$db.collection("countries").doc(this.countryObj.id).get()
      .then(function(doc) {
        
        if (doc.exists && doc.data().thumbnail) {
          // console.log(doc.data());
          that.thumbnail = doc.data().thumbnail;
        } else {
          that.$db.collection("pages").where('countries', 'array-contains', that.countryObj.id).orderBy("year", "desc").orderBy("added", "desc").limit(1).get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                that.thumbnail = doc.data().image;
            
            });
          })
          .catch(function(error) {
              console.log("Error getting thumbnail for country: " + that.countryObj.id, error);
              that.loading = false;
          })
        }
      })
      .catch(function(error) {
          console.log("Error getting thumbnail for country: " + that.countryObj.id, error);
          that.loading = false;
      });
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .country-card  {
    color:black;
    font-weight:bold;
    border: 5px solid white;
  }
  .country-card {
    max-width: 1000px;
  }
</style>


// WEBPACK FOOTER //
// src/components/CountryRow.vue